import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgQuoteClose = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 86,
	height: 59,
	viewBox: "0 0 86 59",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	className: "quote-mark-svg quote-mark-close",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M46.6777 0H85.4277V30.9395C85.4277 36.0658 84.5397 40.3848 82.7637 43.8965C80.9876 47.3678 78.6465 50.1934 75.7402 52.373C72.834 54.5124 69.5241 56.0462 65.8105 56.9746C62.097 57.903 58.3027 58.3672 54.4277 58.3672V38.75C55.1947 38.7096 56.0221 38.5684 56.9102 38.3262C57.7982 38.084 58.6257 37.6803 59.3926 37.1152C60.1595 36.5501 60.8053 35.7832 61.3301 34.8145C61.8548 33.8053 62.1172 32.5339 62.1172 31H46.6777V0ZM0.177734 0H38.9277V30.9395C38.9277 36.0658 38.0397 40.3848 36.2637 43.8965C34.4876 47.3678 32.1465 50.1934 29.2402 52.373C26.334 54.5124 23.0241 56.0462 19.3105 56.9746C15.597 57.903 11.8027 58.3672 7.92773 58.3672V38.75C8.69466 38.7096 9.52214 38.5684 10.4102 38.3262C11.2982 38.084 12.1257 37.6803 12.8926 37.1152C13.6595 36.5501 14.3053 35.7832 14.8301 34.8145C15.3548 33.8053 15.6172 32.5339 15.6172 31H0.177734V0Z",
		fill: "#FF5789"
	})
});
export default SvgQuoteClose;
